module.exports = __webpack_public_path__ + "img/pass.5e77ab2a.png";